(function() {
'use strict';

function byId(id){ return document.getElementById(id); }
function showEl(id, display){ var e=byId(id); if(e) e.style.display=display||'block'; }
function hideEl(id){ var e=byId(id); if(e) e.style.display='none'; }

function setBusy(busy){
  var btn=byId('signInBtn');
  if(!btn) return;
  btn.disabled=!!busy;
  btn.style.opacity=busy?'.65':'1';
  btn.textContent=busy?'Signing in…':'Sign In to Training Portal →';
}

function initProgress(role){
  (productionUnits || []).forEach(function(u){
    if(!unitProgress[u.id]) unitProgress[u.id]={read:false,score:null,passed:false};
  });
}

function setTopbar(name,role,profileRole){
  var pill=byId('userPill'), badge=byId('roleBadge');
  if(pill) pill.textContent=name;
  if(badge){
    var shownRole=profileRole || role;
   badge.textContent =
  demoMode && shownRole === 'admin'
    ? 'Executive / Administration'
    : shownRole === 'admin'
      ? 'Chief Executive Officer'
      : shownRole === 'leadership'
        ? 'Executive Leadership'
        : shownRole === 'trainer'
          ? 'Leadership'
          : 'Employee';
    badge.className='role-badge '+(role==='leadership'?'leadership':role);
  }
}

function openApp(){
  hideEl('loginScreen');

  var app = byId('app');
  if(app) app.classList.add('visible');

  buildNav();

  let restoredView = 'dashboard';

try {
  const savedWorkspace =
    sessionStorage.getItem('corevianCurrentWorkspace');

  if (savedWorkspace) {
    const workspace = JSON.parse(savedWorkspace);

    if (
      workspace?.type === 'assignmentEligibility' &&
      workspace?.userId &&
      typeof openEmployeeAssignmentEligibility === 'function'
    ) {
      openEmployeeAssignmentEligibility(workspace.userId);
      return;
    }
  }

  if (!demoMode) {
    const savedView =
      sessionStorage.getItem('corevianCurrentView');

    if (savedView) {
      restoredView = savedView;
    }
  }

} catch (err) {
  console.warn(
    'Unable to restore Corevian workspace:',
    err
  );
}

showView(restoredView);
}

function returnToEntry(clearLogin){
  var app=byId('app');
  if(app) app.classList.remove('visible');
  showEl('loginScreen','flex');
  hideEl('demoBanner');
  hideEl('demoBannerSpacer');
  var sw=byId('demoRoleSwitcher');
  if(sw) sw.style.display='none';

  // FIX: window.demoMode was never reset here, so it could stay stuck
  // `true` after any demo role switch, even into a later real session
  // in the same tab. corevian-university-operating-system.js's
  // isDemoMode() checks window.demoMode as its PRIMARY signal, so a
  // stuck-true value could incorrectly block a real CEO/admin from
  // the Operating System after any prior demo use.
  window.demoMode=false;
  window.currentUser=null;
  window.currentRole=null;
  window.currentProfileRole=null;
  window.unitProgress={};
  window.productionUnits=[];
  window.currentEnrollment=null;
  window.currentCurriculumVersionId=null;
  window.currentView='dashboard';

  if(clearLogin){
    var e=byId('loginEmail'), p=byId('loginPassword');
    if(e) e.value='';
    if(p) p.value='';
  }
}

async function loadAuthorizedProfile(user) {
  const client = getSupabaseClient();

  if (!client || !user) {
    throw new Error('Supabase is not configured.');
  }

  let lastError = null;

  for (let attempt = 1; attempt <= 3; attempt++) {
    const result = await client
      .from('profiles')
      .select('user_id, full_name, role, job_title, active')
      .eq('user_id', user.id)
      .maybeSingle();

    if (!result.error) {
      const profile = result.data;

      if (!profile) {
        throw new Error(
          'Your authentication account exists, but no Corevian University profile is assigned. Contact Operations.'
        );
      }

      if (profile.active !== true) {
        throw new Error(
          'This Corevian University profile is inactive. Contact Operations.'
        );
      }

      if (
        !['employee', 'trainer', 'leadership', 'admin']
          .includes(profile.role)
      ) {
        throw new Error(
          'Your Corevian University role is not valid. Contact Operations.'
        );
      }

      return profile;
    }

    lastError = result.error;

    console.warn(
      `Profile load attempt ${attempt} failed:`,
      result.error
    );

    if (attempt < 3) {
      await new Promise(resolve =>
        setTimeout(resolve, attempt * 800)
      );
    }
  }

  console.error(
    'Unable to load authorized Corevian profile:',
    lastError
  );

  throw new Error(
    'Corevian University could not verify your staff profile because the secure data service is temporarily unavailable. Please try again.'
  );
}

function mapProductionUnit(row){
  let content = row && row.content_json ? row.content_json : {};
  if (typeof content === 'string') {
    try { content = JSON.parse(content); } catch (_) { content = {}; }
  }
  if (!content || typeof content !== 'object') content = {};

  const sections = Array.isArray(content.sections) ? content.sections.map(function(sec){
    return {
      h: sec && sec.h != null ? String(sec.h) : '',
      body: sec && sec.body != null ? String(sec.body) : ''
    };
  }) : [];

  const quiz = Array.isArray(content.quiz) ? content.quiz.map(function(q){
    const rawCorrect = q && q.correct != null ? Number(q.correct) : -1;
    return {
      q: q && q.q != null ? String(q.q) : '',
      opts: q && Array.isArray(q.opts) ? q.opts.map(function(opt){ return String(opt); }) : [],
      correct: Number.isInteger(rawCorrect) ? rawCorrect : -1,
      feedback: q && q.feedback != null ? String(q.feedback) : ''
    };
  }) : [];

  return {
    id: Number(row.display_order || row.unit_number),
    dbId: row.id,
    num: String(row.unit_number).padStart(2,'0'),
    code: row.unit_code,
    title: row.title || ('Unit '+row.unit_number),
    role: row.role_scope,
    masteryPercent: Number(row.mastery_percent || 90),
    sections: sections,
    questions: Array.isArray(content.questions) ? content.questions.map(function(x){ return String(x); }) : [],
    quiz: quiz
  };
}

async function loadProductionTrainingState(user, profile){
  const client=getSupabaseClient();
  const enrollmentResult=await client.from('enrollments')
    .select('id,user_id,curriculum_version_id,assigned_role,assigned_at,due_at,completed_at,active')
    .eq('user_id', user.id).eq('active', true).order('assigned_at', {ascending:false}).limit(1);
  if(enrollmentResult.error) throw enrollmentResult.error;
  const enrollment=enrollmentResult.data && enrollmentResult.data[0];
  if(!enrollment) throw new Error('Your Corevian University profile is active, but no active curriculum enrollment is assigned. Contact Operations.');
  currentEnrollment=enrollment;
  currentCurriculumVersionId=enrollment.curriculum_version_id;

  const unitsResult=await client.from('curriculum_units')
    .select('id,curriculum_version_id,unit_number,unit_code,title,role_scope,display_order,required,mastery_percent,content_json,active')
    .eq('curriculum_version_id', enrollment.curriculum_version_id).eq('active', true).order('display_order', {ascending:true});
  if(unitsResult.error) throw unitsResult.error;
  let rows=unitsResult.data || [];
 const assignedRole = enrollment.assigned_role;

if (assignedRole === 'admin' || assignedRole === 'leadership') {
  rows = rows.filter(r =>
    ['employee', 'leadership', 'admin'].includes(r.role_scope)
  );
} else if (assignedRole === 'trainer') {
  rows = rows.filter(r =>
    ['employee', 'leadership'].includes(r.role_scope)
  );
} else {
  rows = rows.filter(r => r.role_scope === 'employee');
}

  productionUnits=rows.map(mapProductionUnit);
  if(!productionUnits.length) throw new Error('No active controlled curriculum units were found for this enrollment. Contact Operations.');

  const progressResult=await client.from('unit_progress')
    .select('id,enrollment_id,unit_id,status,started_at,completed_at,best_score,attempt_count,acknowledged_at,updated_at')
    .eq('enrollment_id', enrollment.id);
  if(progressResult.error) throw progressResult.error;
  const byUnitId=new Map((progressResult.data || []).map(p => [p.unit_id,p]));
  unitProgress={};
  const missing=[];
  productionUnits.forEach(u => {
    const p=byUnitId.get(u.dbId);
    if(!p){ missing.push(u.code || u.num); return; }
    const scorePct=p.best_score === null || p.best_score === undefined ? null : Number(p.best_score);
    unitProgress[u.id]={dbProgressId:p.id,dbUnitId:u.dbId,read:p.status!=='not_started',status:p.status,
      score:scorePct===null?null:scorePct/100,bestScorePercent:scorePct,passed:p.status==='passed',
      attemptCount:Number(p.attempt_count||0),startedAt:p.started_at||null,completedAt:p.completed_at||null};
  });
  if(missing.length) throw new Error('Progress initialization is incomplete for: '+missing.join(', ')+'. Contact Operations.');

  const assessmentType=['trainer','leadership','admin'].includes(enrollment.assigned_role)?'leadership_final':'employee_final';
  const finalAttempts=await client.from('assessment_attempts')
    .select('attempt_number,score_percent,passed,submitted_at')
    .eq('enrollment_id',enrollment.id).eq('assessment_type',assessmentType).is('unit_id',null)
    .order('attempt_number',{ascending:false});
  if(finalAttempts.error) throw finalAttempts.error;
  const attempts=finalAttempts.data||[];
  const finalAssessmentStatus={
    passed:attempts.some(a=>a.passed===true),
    bestScorePercent:attempts.length?Math.max(...attempts.map(a=>Number(a.score_percent||0))):null,
    attemptCount:attempts.length?Math.max(...attempts.map(a=>Number(a.attempt_number||0))):0,
    assessmentType:assessmentType
  };
}
// ═══════════════════════════════════════════════════════════════════
// PERSONNEL TRAINING RECORD — MANAGEMENT READ PATH (NON-MUTATING)
// Reuses the exact same tables/logic as loadProductionTrainingState(),
// but for a target employee rather than the signed-in session, and
// never writes to currentEnrollment, currentCurriculumVersionId,
// productionUnits, unitProgress, or any other session-level state.
// ═══════════════════════════════════════════════════════════════════

async function loadPersonnelTrainingRecord(targetUserId) {
  const client = getSupabaseClient();

  // 1. Target employee's own active enrollment — never the viewer's.
  const enrollmentResult = await client
    .from('enrollments')
    .select('id,user_id,curriculum_version_id,assigned_role,assigned_at,due_at,completed_at,active')
    .eq('user_id', targetUserId)
    .eq('active', true)
    .order('assigned_at', { ascending: false })
    .limit(1);

  if (enrollmentResult.error) throw enrollmentResult.error;

  const enrollment = enrollmentResult.data && enrollmentResult.data[0];

  if (!enrollment) {
    return {
      hasEnrollment: false,
      units: [],
      totalCount: 0,
      passedCount: 0,
      remainingCount: 0,
      completionPercent: 0,
      missingProgressCount: 0,
      finalAssessmentStatus: null
    };
  }

  // 2. Curriculum units for THIS employee's curriculum_version_id,
  //    scoped by THIS employee's own assigned_role — not the viewer's.
  const unitsResult = await client
    .from('curriculum_units')
    .select('id,curriculum_version_id,unit_number,unit_code,title,role_scope,display_order,required,mastery_percent,active')
    .eq('curriculum_version_id', enrollment.curriculum_version_id)
    .eq('active', true)
    .order('display_order', { ascending: true });

  if (unitsResult.error) throw unitsResult.error;

  let unitRows = unitsResult.data || [];

  const assignedRole = enrollment.assigned_role;

  if (assignedRole === 'admin' || assignedRole === 'leadership') {
    unitRows = unitRows.filter(r =>
      ['employee', 'leadership', 'admin'].includes(r.role_scope)
    );
  } else if (assignedRole === 'trainer') {
    unitRows = unitRows.filter(r =>
      ['employee', 'leadership'].includes(r.role_scope)
    );
  } else {
    unitRows = unitRows.filter(r => r.role_scope === 'employee');
  }

  // Lightweight unit shape for this read path — no quiz/section content_json
  // needed for a management summary, unlike mapProductionUnit().
  const units = unitRows.map(row => ({
    dbId: row.id,
    num: String(row.unit_number).padStart(2, '0'),
    code: row.unit_code,
    title: row.title || ('Unit ' + row.unit_number),
    roleScope: row.role_scope
  }));

  // 3. Progress for THIS employee's enrollment.
  const progressResult = await client
    .from('unit_progress')
    .select('id,enrollment_id,unit_id,status,started_at,completed_at,best_score,attempt_count,updated_at')
    .eq('enrollment_id', enrollment.id);

  if (progressResult.error) throw progressResult.error;

  const progressByUnitId = new Map(
    (progressResult.data || []).map(p => [p.unit_id, p])
  );

  let passedCount = 0;
  let missingProgressCount = 0;

  const unitRecords = units.map(u => {
    const p = progressByUnitId.get(u.dbId);

    if (!p) {
      missingProgressCount++;
      return {
        ...u,
        status: 'no_progress_record',
        statusLabel: 'NO PROGRESS RECORD',
        isDataIntegrityIssue: true,
        score: null,
        completedAt: null,
        attemptCount: 0
      };
    }

    const statusLabelMap = {
      passed: 'PASSED',
      in_progress: 'IN PROGRESS',
      not_started: 'NOT STARTED',
      failed: 'FAILED'
    };

    if (p.status === 'passed') passedCount++;

    return {
      ...u,
      status: p.status,
      statusLabel: statusLabelMap[p.status] || String(p.status || '').toUpperCase(),
      isDataIntegrityIssue: false,
      score: p.best_score === null || p.best_score === undefined ? null : Number(p.best_score),
      completedAt: p.completed_at || null,
      attemptCount: Number(p.attempt_count || 0)
    };
  });

  const totalCount = units.length;
  const remainingCount = totalCount - passedCount;
  const completionPercent = totalCount > 0
    ? Math.round((passedCount / totalCount) * 100)
    : 0;

  // 4. Final assessment, resolved by THIS employee's assigned_role.
  const assessmentType = ['trainer', 'leadership', 'admin'].includes(assignedRole)
    ? 'leadership_final'
    : 'employee_final';

  const finalAttemptsResult = await client
    .from('assessment_attempts')
    .select('attempt_number,score_percent,passed,submitted_at')
    .eq('enrollment_id', enrollment.id)
    .eq('assessment_type', assessmentType)
    .is('unit_id', null)
    .order('attempt_number', { ascending: false });

  if (finalAttemptsResult.error) throw finalAttemptsResult.error;

  const finalAttempts = finalAttemptsResult.data || [];

  const finalAssessmentStatus = {
    passed: finalAttempts.some(a => a.passed === true),
    bestScorePercent: finalAttempts.length
      ? Math.max(...finalAttempts.map(a => Number(a.score_percent || 0)))
      : null,
    attemptCount: finalAttempts.length
      ? Math.max(...finalAttempts.map(a => Number(a.attempt_number || 0)))
      : 0,
    assessmentType
  };

  return {
    hasEnrollment: true,
    enrollmentId: enrollment.id,
    curriculumVersionId: enrollment.curriculum_version_id,
    assignedRole,
    units: unitRecords,
    totalCount,
    passedCount,
    remainingCount,
    completionPercent,
    missingProgressCount,
    finalAssessmentStatus
  };
}

window.loadPersonnelTrainingRecord = loadPersonnelTrainingRecord;

async function persistUnitStarted(u){
  if(demoMode || !currentEnrollment || !u || !u.dbId) return;
  const p=unitProgress[u.id];
  if(!p || p.status !== 'not_started') return;
  const now=new Date().toISOString();
  const result=await getSupabaseClient().from('unit_progress')
    .update({status:'in_progress',started_at:now,updated_at:now})
    .eq('enrollment_id', currentEnrollment.id).eq('unit_id',u.dbId)
    .select('id,status,started_at,attempt_count,best_score').single();
  if(result.error) throw result.error;
  p.status='in_progress'; p.read=true; p.startedAt=result.data.started_at||now;
}

async function persistQuizResult(u, answers, pct, passed, correctCount){
  if(!currentEnrollment || !u || !u.dbId) throw new Error('No active production enrollment is loaded.');
  const client=getSupabaseClient();
  const p=unitProgress[u.id] || {};
  const attemptNumber=Number(p.attemptCount||0)+1;
  const now=new Date().toISOString();
  const startedAt=p.startedAt||now;
  const answerPayload={curriculum_version_id:currentCurriculumVersionId,unit_code:u.code,total_questions:u.quiz.length,
    correct_count:correctCount,answers:u.quiz.map((q,i)=>({question_number:i+1,selected_index:answers[i],correct_index:q.correct,is_correct:answers[i]===q.correct}))};

  const attemptResult=await client.from('assessment_attempts').insert({enrollment_id:currentEnrollment.id,unit_id:u.dbId,
    assessment_type:'unit_quiz',attempt_number:attemptNumber,score_percent:pct,passed:passed,answer_payload:answerPayload,
    started_at:startedAt,graded_by:'system'});
  if(attemptResult.error) throw attemptResult.error;

  const previousBest=p.bestScorePercent===null||p.bestScorePercent===undefined?null:Number(p.bestScorePercent);
  const bestScore=previousBest===null?pct:Math.max(previousBest,pct);
  const progressResult=await client.from('unit_progress')
    .update({status:passed?'passed':'failed',started_at:startedAt,completed_at:passed?now:null,best_score:bestScore,
      attempt_count:attemptNumber,updated_at:now})
    .eq('enrollment_id',currentEnrollment.id).eq('unit_id',u.dbId)
    .select('id,status,started_at,completed_at,best_score,attempt_count').single();
  if(progressResult.error) throw progressResult.error;
  unitProgress[u.id]={...p,read:true,status:progressResult.data.status,score:pct/100,bestScorePercent:Number(progressResult.data.best_score),
    passed:progressResult.data.status==='passed',attemptCount:Number(progressResult.data.attempt_count),startedAt:progressResult.data.started_at,
    completedAt:progressResult.data.completed_at};
}

window.persistUnitStarted = persistUnitStarted;
window.persistQuizResult = persistQuizResult;

async function establishStaffSession(user){
  var profile=await loadAuthorizedProfile(user);
  demoMode=false;
  currentUser=profile.full_name;
  currentProfileRole=profile.role;
  // FIX: keep window.demoMode/window.currentUser in sync with the
  // bare module-scope variables above (see resetCorevianIdleTimer and
  // returnToEntry for why this matters).
  window.demoMode=false;
  window.currentUser=profile.full_name;
  await loadProductionTrainingState(user, profile);

currentRole =
  currentEnrollment && currentEnrollment.assigned_role
    ? currentEnrollment.assigned_role
    : profile.role;

initProgress(currentRole);
setTopbar(profile.full_name, currentRole, profile.role);
startCorevianSessionSecurity();
openApp();
  
}

async function signIn(){
  var emailEl=byId('loginEmail'), passEl=byId('loginPassword');
  var email=emailEl ? emailEl.value.trim() : '';
  var password=passEl ? passEl.value : '';

  if(!supabaseConfigured()){
    showError('Auth development file is ready, but the Supabase Project URL and publishable key have not been added yet.');
    return;
  }
  if(!email){ showError('Please enter your Corevian work email.'); return; }
  if(!password){ showError('Please enter your password.'); return; }

  setBusy(true);
  try{
    var client=getSupabaseClient();
    var response=await client.auth.signInWithPassword({email:email,password:password});
    if(response.error) throw response.error;
    await establishStaffSession(response.data.user);
  }catch(err){
    console.error('SIGN IN ORIGINAL ERROR:', err);
    var client=getSupabaseClient();
    if(client) await client.auth.signOut();
    showError(err && err.message ? err.message : 'Unable to sign in. Contact Operations.');
  }finally{
    setBusy(false);
  }
}
window.signIn = signIn;

var signInBtn = byId('signInBtn');
if (signInBtn) {
  signInBtn.addEventListener('click', signIn);
}
function enterDemo(){
  demoMode=true;
  currentUser='Demo Session';
  currentRole='leadership';
  // FIX: mirror onto window so isDemoMode()'s primary check
  // (window.demoMode === true) is actually reliable from the moment
  // demo starts, not only after a role switch.
  window.demoMode=true;
  window.currentUser='Demo Session';
  window.currentRole='leadership';
  unitProgress={};
  initProgress(currentRole);

  var banner=byId('demoBanner'), spacer=byId('demoBannerSpacer'), sw=byId('demoRoleSwitcher');
  if(banner) banner.style.display='flex';
  if(spacer) spacer.style.display='block';
  if(sw) sw.style.display='flex';

  setTopbar('Demo Session','leadership','leadership');
  updateDemoButtons('leadership');
  openApp();
}
window.enterDemo = enterDemo;
async function exitOrSignOut(event){
  if(event && event.preventDefault) event.preventDefault();

 if(demoMode){
  demoMode=false;
  // FIX: reset the window mirror the moment demo mode is exited,
  // rather than leaving it stuck true until (never) reset.
  window.demoMode=false;

  var banner=byId('demoBanner');
  var spacer=byId('demoBannerSpacer');
  var sw=byId('demoRoleSwitcher');

  if(banner) banner.style.display='none';
  if(spacer) spacer.style.display='none';
  if(sw) sw.style.display='none';

  await restoreSession();
  return;
}
  var btn=byId('logoutBtn');
  var originalText=btn ? btn.textContent : '';
  if(btn){
    btn.disabled=true;
    btn.textContent='Signing out…';
  }

  try{
    var client=getSupabaseClient();
    if(!client) throw new Error('Supabase client is unavailable.');

    var signOutPromise=client.auth.signOut({scope:'local'});
    var timeoutPromise=new Promise(function(resolve){
      setTimeout(function(){ resolve({timedOut:true}); }, 3500);
    });
    var result=await Promise.race([signOutPromise, timeoutPromise]);

    try{
      var projectRef='xoolcbbpnvdylcoorlqg';
      var exactKey='sb-'+projectRef+'-auth-token';
      localStorage.removeItem(exactKey);
      Object.keys(localStorage).forEach(function(k){
        if(k.indexOf('sb-'+projectRef)===0 && k.indexOf('auth')!==-1) localStorage.removeItem(k);
      });
      sessionStorage.clear();
    }catch(storageErr){
      console.warn('Corevian local session cleanup warning:', storageErr);
    }

    if(result && result.error) console.warn('Supabase local sign-out warning:', result.error);

    demoMode=false;
    returnToEntry(true);
  }catch(err){
    try{
      var projectRef='xoolcbbpnvdylcoorlqg';
      localStorage.removeItem('sb-'+projectRef+'-auth-token');
      sessionStorage.clear();
    }catch(ignoreErr){}
    demoMode=false;
    returnToEntry(true);
    console.error('Corevian sign-out warning:', err);
  }finally{
    if(btn){
      btn.disabled=false;
      btn.textContent=originalText || '← Sign Out';
    }
  }
}
const COREVIAN_IDLE_TIMEOUT_MS = 15 * 60 * 1000;
const COREVIAN_MAX_SESSION_MS = 8 * 60 * 60 * 1000;

let corevianIdleTimer = null;
let corevianAbsoluteTimer = null;
let corevianSessionStartedAt = null;

function clearCorevianSessionTimers(){
  if(corevianIdleTimer){
    clearTimeout(corevianIdleTimer);
    corevianIdleTimer = null;
  }

  if(corevianAbsoluteTimer){
    clearTimeout(corevianAbsoluteTimer);
    corevianAbsoluteTimer = null;
  }
}
  async function corevianSecuritySignOut(reason){
  clearCorevianSessionTimers();

  corevianSessionStartedAt = null;

  try{
    sessionStorage.setItem(
      'corevianSignOutReason',
      reason || 'security_timeout'
    );
  }catch(err){}

  await exitOrSignOut();
}

function resetCorevianIdleTimer(){
  // FIX: demoMode/currentUser are declared with `let` in
  // corevian-university-2.js, which does NOT attach them to `window`.
  // The window-prefixed check below was always false/undefined here,
  // so this function returned early on every call and the idle timer
  // was never armed. Using the bare variables matches the already-
  // correct pattern in startCorevianSessionSecurity() just below.
  if(demoMode || !currentUser) return;

  if(corevianIdleTimer){
    clearTimeout(corevianIdleTimer);
  }

  corevianIdleTimer = setTimeout(function(){
    corevianSecuritySignOut('inactivity_timeout');
  }, COREVIAN_IDLE_TIMEOUT_MS);
}

function startCorevianSessionSecurity(){
  if(demoMode || !currentUser) return;

  clearCorevianSessionTimers();

  if(!corevianSessionStartedAt){
  try{
    const savedSessionStart =
      sessionStorage.getItem('corevianSessionStartedAt');

    if(savedSessionStart){
      corevianSessionStartedAt =
        Number(savedSessionStart);
    }else{
      corevianSessionStartedAt =
        Date.now();

      sessionStorage.setItem(
        'corevianSessionStartedAt',
        String(corevianSessionStartedAt)
      );
    }
  }catch(err){
    corevianSessionStartedAt = Date.now();
  }
}

  resetCorevianIdleTimer();

  const elapsed =
    Date.now() - corevianSessionStartedAt;

  const remaining =
    COREVIAN_MAX_SESSION_MS - elapsed;

  if(remaining <= 0){
    corevianSecuritySignOut('maximum_session_timeout');
    return;
  }

  corevianAbsoluteTimer = setTimeout(function(){
    corevianSecuritySignOut('maximum_session_timeout');
  }, remaining);
}

['click','keydown','mousemove','scroll','touchstart'].forEach(function(eventName){
  document.addEventListener(
    eventName,
    resetCorevianIdleTimer,
    { passive:true }
  );
});

function switchDemoRole(role){

  if(!window.demoMode) return;

  currentRole=role;

  window.demoMode=true;
  window.currentRole=role;

  unitProgress={};

  initProgress(role);

  setTopbar('Demo Session',role,role);

  updateDemoButtons(role);

  buildNav();

  window.dispatchEvent(new CustomEvent('corevian:demo-role-changed',{
    detail:{ role:role }
  }));

  showView('dashboard');

}

function updateDemoButtons(active){
  var colors={
    employee:{
      bg:'rgba(22,163,74,.15)',
      border:'rgba(22,163,74,.4)',
      color:'#4ADE80'
    },
    trainer:{
      bg:'rgba(245,158,11,.15)',
      border:'rgba(245,158,11,.4)',
      color:'#FCD34D'
    },
    leadership:{
      bg:'rgba(124,58,237,.15)',
      border:'rgba(124,58,237,.4)',
      color:'#C4B5FD'
    },
    admin:{
      bg:'rgba(14,165,233,.15)',
      border:'rgba(14,165,233,.4)',
      color:'#7DD3FC'
    }
  };

  document.querySelectorAll('[data-drole]').forEach(function(btn){
    var r=btn.getAttribute('data-drole');
    var activeBtn=r===active;
    var roleColor=colors[r];

    btn.style.background=
      activeBtn && roleColor
        ? roleColor.bg
        : 'transparent';

    btn.style.borderColor=
      activeBtn && roleColor
        ? roleColor.border
        : 'rgba(255,255,255,.15)';

    btn.style.color=
      activeBtn && roleColor
        ? roleColor.color
        : 'rgba(255,255,255,.5)';
  });
}
async function restoreSession(){
  if(!supabaseConfigured()) return;

  try{
    const client = getSupabaseClient();

    const { data, error } =
      await client.auth.getSession();

    if(error) throw error;

    if(data?.session?.user){
      await establishStaffSession(
        data.session.user
      );
      return;
    }

    returnToEntry(false);

  }catch(err){
    console.error(
      'Session restoration failed:',
      err
    );

    returnToEntry(false);
  }
}
function init(){
  var sign=byId('signInBtn');
  if(sign) sign.addEventListener('click',signIn);

  var demo=byId('enterDemoBtn');
  if(demo) demo.addEventListener('click',enterDemo);

  var exitBanner=byId('exitDemoBtn');
  if(exitBanner) exitBanner.addEventListener('click',exitOrSignOut);

  document.querySelectorAll('[data-drole]').forEach(function(btn){
    btn.addEventListener('click',function(){ switchDemoRole(this.getAttribute('data-drole')); });
  });

  var email=byId('loginEmail'), pass=byId('loginPassword');
  if(email) email.addEventListener('keydown',function(e){ if(e.key==='Enter' && pass) pass.focus(); });
  if(pass) pass.addEventListener('keydown',function(e){ if(e.key==='Enter') signIn(); });

  window.doLogin=signIn;
  window.doLogout=exitOrSignOut;
  window.launchDemo=enterDemo;
  window.exitDemo=exitOrSignOut;
  window.switchDemoRole=switchDemoRole;

  restoreSession();
}

if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
else init();

})();